import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import finish from "../../../../../../assets/images/Auditions/finish.png";
import flag from "../../../../../../assets/images/Auditions/flag.png";
import clock from "../../../../../../assets/images/meetupEvent/clock.png";
import Price from "../../../../../../assets/images/tagPrice.PNG";
import "./PendingProductDetails.css";
import "./SuperStarContent.css";

const PendingProductDetails = () => {
  
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const { id } = useParams();

  const [product, setPendingProduct] = useState([]);

  const editProduct = () => {
    history.push(`/superstar-admin/edit-auction/${id}`);
  };

  useEffect(() => {
    axios.get(`/api/admin/show/auction/product/${id}`).then((res) => {
      if (res.status === 200) {
        setPendingProduct(res.data.product);
      }
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8 mb-3">
          <div className="card card-bg p-2 mb-3">
            <img
              className="img-fluid banner-pro"
              src={imageCdnUrl + product.banner}
              alt=""
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + product.product_image}
              alt="Pineapple"
              className="img-fluid banner-pro"
            />
          </div>
        </div>
        <div className="col-md-12 mb-3">
          <div className="card-body card-bg">
            <h5 className="text-light ">{product.title}</h5>
            <h5 className="text-warning">Description</h5>

            <div className="under-line"></div>
            <p className="text-light mt-2">
              <Markup content={product.details} />
            </p>
          </div>
        </div>
      </div>

      <div className=" row mt-2 cricket-jersey">
        <div className="col-sm-12 col-md-6 col-lg-3 p-2 mb-3">
          <div className="p-2 d-flex align-items-center  registration-btn card-bg ">
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={flag} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Start Bidding Date & Time</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(product.bid_from).format("LL")}{" "}
                {moment(product.bid_from, "HH:mm:ss").format("hh:mm A")}
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3 p-2 mb-3">
          <div className=" p-2 d-flex align-items-center registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={finish} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">End Bidding Date & Time</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(product.bid_to).format("LL")}{" "}
                {moment(product.bid_to, "HH:mm:ss").format("hh:mm A")}
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3 p-2 mb-3">
          <div className=" p-2 d-flex align-items-center  registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={flag} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Result Published</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(product.result_date).format("LL")}
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3 p-2 mb-3">
          <div className=" p-2 d-flex align-items-center registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Price} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Base Price</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                ${product.base_price}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-bg mt-4">
        <div className="row">
          <div className="col-md-4 d-flex justify-content-center align-items-center">
            <img src={clock} className="img-fluid p-3" alt="" />
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <div>
              <h2 className="text-warning">Product Details submitted</h2>

              <p className="text-light">
                {product.status === 1 ? (
                  <span className="fw-bold">Already Published</span>
                ) : product.star_approval === 1 ? (
                  <span className="fw-bold">
                    Waiting for &nbsp; Manager Admin Approval
                  </span>
                ) : (
                  <span className="fw-bold">
                    Waiting for &nbsp; Star & Manager Admin Approval
                  </span>
                )}
                &nbsp;
              </p>
              {product.star_approval < 1 ? (
                <div className="mt-3 row">
                  <div className="col-md-8">
                    <button
                      className="btn btn-sm btnEditTest py2"
                      type="submit"
                      onClick={editProduct}
                    >
                      <big>
                        <b>Edit Auction</b>
                      </big>
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-md-4" style={{ borderLeft: "1px dashed yellow" }}>
            <h5 className="text-light text-center my-3">Status</h5>
            <div className="d-flex justify-content-center align-items-center ">
              <div style={{ width: 150, height: 150 }}>
                {product.status === 1 ? (
                  <CircularProgressbarWithChildren
                    value={100}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">100% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                ) : product.star_approval === 1 ? (
                  <CircularProgressbarWithChildren
                    value={50}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">50% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                ) : (
                  <CircularProgressbarWithChildren
                    value={0}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">0% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingProductDetails;
